export interface SupabaseEnvironment {
  [key: string]: string | undefined;
  NEXT_PUBLIC_SUPABASE_URL?: string;
  NEXT_PUBLIC_SUPABASE_ANON_KEY?: string;
  SUPABASE_URL?: string;
  SUPABASE_ANON_KEY?: string;
}

export interface SupabaseConfig {
  url: string;
  anonKey: string;
}

/**
 * Reads the public Supabase URL and anonymous key used by SSR clients.
 *
 * @param environment Environment values to read.
 * @returns Validated Supabase URL and anonymous key.
 * @throws Error when either public client value is missing.
 */
export function getSupabaseConfig(environment: SupabaseEnvironment = process.env): SupabaseConfig {
  const url = environment.NEXT_PUBLIC_SUPABASE_URL ?? environment.SUPABASE_URL;
  const anonKey = environment.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? environment.SUPABASE_ANON_KEY;

  if (!url || !anonKey)
    throw new Error('Supabase public client configuration is missing.');

  return { url, anonKey };
}

/**
 * Reads the public Supabase values that Next.js exposes to browser bundles.
 *
 * These property accesses must remain static so Next.js can inline the
 * `NEXT_PUBLIC_*` values during the client build.
 */
export function getBrowserSupabaseConfig(): SupabaseConfig {
  return getSupabaseConfig({
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  });
}
